import { Flex, Pane } from '@leverege/ui-elements'
import { TitleBar, useSharedContext } from '@leverege/ui-plugin'
import { DateTime, Interval } from 'luxon'
import React, { useMemo } from 'react'

import { getUtilizationStats } from '../../../../util'
import StationUtilizationTable from './StationUtilizationTable'

export default function PerDayStats( { data, businessDays, loading } ) {
  const isMultiDay = businessDays.length > 1
  const { timezone } = useSharedContext()

  const { dogInStationStats } = useMemo( () => {
    const stationData = Array.from( data.bins.values() )
      .sort( ( a, b ) => {
        return a.obj?.data.name < b.obj?.data.name ? -1 : 1
      } )

    const dogInStationStats = stationData.reduce( ( prev, station ) => {
      if ( station.obj ) {
        prev.push( {
          name : station.obj.data.name,
          ...getUtilizationStats( data, businessDays, 'dogInStation', station.deviceId, timezone )
        } )
      }

      return prev
    }, [] )

    return {
      dogInStationStats
    }
  }, [ businessDays, data, timezone ] )

  const { businessHours } = useMemo( () => {
    const bd = businessDays

    let totalHours = 0
    if ( bd.length > 0 ) {
      const now = Date.now()
      bd.forEach( ( [ startTS, endTS ] ) => {
        if ( startTS > now ) {
          return
        }

        totalHours += Interval.fromDateTimes(
          DateTime.fromMillis( startTS ),
          DateTime.fromMillis( endTS )
        ).length( 'hours' )
      } )
    }

    return { businessHours : totalHours, businessDays : bd }
  }, [ businessDays ] )

  return (
    <Flex variant="rowL">
      <Pane variant="card">
        <TitleBar
          variant="analyticsCardTitle|cardTitle"
          icon={loading ? 'fa fa-spin fa-circle-o-notch' : undefined}
          title={`Station Utilization per Day ${isMultiDay ? ' (Avg)' : ''}`} />
        <StationUtilizationTable
          businessHours={businessHours}
          data={dogInStationStats.slice( 0, dogInStationStats.length / 2 )}
          businessDays={businessDays} />
      </Pane>
      <Pane variant="card">
        <TitleBar
          variant="analyticsCardTitle|cardTitle"
          icon={loading ? 'fa fa-spin fa-circle-o-notch' : undefined}
          title=" " />
        <StationUtilizationTable
          businessHours={businessHours}
          data={dogInStationStats.slice( dogInStationStats.length / 2 )}
          businessDays={businessDays} />
      </Pane>
    </Flex>
  )
}
